import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';
import BasicAutosuggest from '../public/AutosuggestComponent';
import CampaignUploadCsv from './CampaignUploadCsv';

import { setAllGeographyOptionArray } from '../../utilities/report-helpers';
import { validateCsv, createCampaign } from '../../store/actions/campaign-summary-actions';
import { fetchAccountList } from '../../store/actions/account-actions';



import moment from 'moment';

const CreateCampaign = () => {
  const dispatch = useDispatch();

  const boundariesData = useSelector(state => state.locations.boundariesData);
  const boundariesDictionary = useSelector(
    state => state.locations.boundariesDictionary
  );

  const validateResponse = useSelector(
    state => state.campaign.validateResponse
  );

  const accountListData = useSelector(
    state => state.account.accountListData
  );

  const [currentAccountName, setCurrentAccountName] = useState(null);
  const [locationArray, setLocationArray] = useState(null);
  const [datesMoment, setDatesMoment] =  useState({
    startDate: moment(),
    endDate: moment()
  });

  const [formData, setFormData] = useState({
    type: 'audienceSummary',
    name: '',
    advertiserName: '',
    agentName: '',
    startDate: moment.utc().format(),
    endDate: moment.utc().format(),
    clickThroughRate: 0.0,
    locationIds: '',
    impressions: 2,
    numOfCustomers: 8,
    accountManagerId: '',
    audienceSummaryCSV: null,
  });

  const [focusedStart, setFocusedStart] = useState(null);
  const [focusedEnd, setFocusedEnd] = useState(null);

  useEffect(() => {
    dispatch(fetchAccountList());
  }, []);

  useEffect(() => {
  }, [formData]);

  const inputOnchange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const valicateCsv = () =>{
    dispatch(validateCsv(formData.audienceSummaryCSV));
  }

  const submitCreateCampaign = () => {
    dispatch(createCampaign(formData));
  };

  return (
    <div>
      <div style={CreateCampaignStyle.container}>
        <div style={CreateCampaignStyle.contentBlock}>
          <div>
            <h3 style={CreateCampaignStyle.fieldName}>Campaign Name</h3>
            <input
              style={CreateCampaignStyle.inputStyle}
              name="name"
              onChange={inputOnchange}
            />
          </div>

          <div>
            <h3 style={CreateCampaignStyle.fieldName}>Advertisers Name</h3>
            {/* <BasicAutosuggest inputType="Advertiser" /> */}
            <input
              style={CreateCampaignStyle.inputStyle}
              name="advertiserName"
              onChange={inputOnchange}
            />
          </div>

          <div style={CreateCampaignStyle.selectArea}>
            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>Agency Name</h3>
              {/* <BasicAutosuggest inputType="Agency" /> */}
              <input
                style={CreateCampaignStyle.inputStyle}
                name="agentName"
                onChange={inputOnchange}
              />
            </div>

            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>Account Manager</h3>
              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isDisabled={false}
                isClearable
                isRtl={false}
                isSearchable
                name="account-manager"
                value={currentAccountName}
                options={accountListData.map(item=>{
                  return {
                    label:item.username,
                    value:item.id,
                  }
                })}
                onChange={event => {
                  setCurrentAccountName(event);
                  event !== null && setFormData({ ...formData, accountManagerId: event.value })
                }}
              />
            </div>

            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>Campaign Start Date</h3>
              <SingleDatePicker
                displayFormat="DD MMM YYYY"
                date={datesMoment.startDate} // momentPropTypes.momentObj or null
                onDateChange={date =>{
                  setDatesMoment({...datesMoment, startDate: date })
                  setFormData({ ...formData, startDate: moment.utc(date).format()  })
                }

                } // PropTypes.func.isRequired
                focused={focusedStart} // PropTypes.bool
                onFocusChange={({ focused }) => setFocusedStart(focused)} // PropTypes.func.isRequired
                id="your_unique_id" // PropTypes.string.isRequired,
                startDate={ moment().subtract(365, "days")}
                isOutsideRange={() => false}
              />
            </div>

            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>Campaign End Date</h3>
              <SingleDatePicker
                displayFormat="DD MMM YYYY"
                date={datesMoment.endDate} // momentPropTypes.momentObj or null
                onDateChange={date =>{
                  setDatesMoment({...datesMoment, endDate: date })
                  setFormData({ ...formData, endDate: moment.utc(date).format() })
                }

                } // PropTypes.func.isRequired
                focused={focusedEnd} // PropTypes.bool
                onFocusChange={({ focused }) => setFocusedEnd(focused)} // PropTypes.func.isRequired
                id="your_unique_id" // PropTypes.string.isRequired,
              />
            </div>
            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>
                Campaign Geographical Targeting
              </h3>

              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isDisabled={false}
                isClearable
                isMulti
                isRtl={false}
                isSearchable
                name="locationIds"
                value={locationArray}
                options={setAllGeographyOptionArray(
                  boundariesData,
                  boundariesDictionary
                )}
                onChange={(e) =>{
                  setFormData({ ...formData, locationIds: e.map(item => item.value).join() });
                  setLocationArray(e);
                }}
              />
            </div>

            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>Impressions</h3>
              <input style={CreateCampaignStyle.inputStyle} />
            </div>

            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>Customers</h3>
              <input style={CreateCampaignStyle.inputStyle} />
            </div>

            <div style={CreateCampaignStyle.inputs}>
              <h3 style={CreateCampaignStyle.fieldName}>CTR</h3>
              <input style={CreateCampaignStyle.inputStyle} />
            </div>
          </div>

          <div style={CreateCampaignStyle.uploadArea}>
            {formData.audienceSummaryCSV === null ? (
              <CampaignUploadCsv
                formData={formData}
                uploadToForm={setFormData}
              />
            ) : (
              <div>
                <h3>File Uploaded</h3>
                  <button onClick={()=>valicateCsv()}>Validate</button>
                  <button onClick={()=> setFormData({ ...formData, audienceSummaryCSV: null })}>Cancel</button>
                  { validateResponse && (
                    <div>
                      <div>Audience Count: {validateResponse.audienceCount}</div>
                      <div>Audience Match: {validateResponse.audienceMatched}</div>
                    </div>
                  )}
              </div>
            )}
          </div>

          <div style={CreateCampaignStyle.createCampaignBtnArea}>
            <div
              style={CreateCampaignStyle.createCampaignBtn}
              onClick={() => submitCreateCampaign()}
            >
              <div style={CreateCampaignStyle.createCampaignBtnText}>
                Create Campaign Audience Summary
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaign;

const CreateCampaignStyle = {
  container: {
    padding: '2rem',
  },
  selectArea: {
    display: 'flex',
    flexFlow: 'wrap',
  },
  contentBlock: {},
  inputs: {
    width: '50%',
    padding: 5,
  },
  inputStyle: {
    width: '100%',
    borderColor: '#cccccc',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    height: '42px',
  },
  fieldName: {
    fontSize: '1rem',
    paddingTop: '1rem',
  },
  uploadArea: {
    height: 260,
    backgroundColor: '#F9FAFB',
    border: '1px dashed #D1D5DB',
    boxSizing: 'border-box',
    borderRadius: '6px',
    margin: 5,
    marginTop: '2rem',
  },
  createCampaignBtnArea: {
    cursor: 'pointer',
    marginLeft: 'auto',
    order: 2,
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  createCampaignBtn: {
    display: 'flex',
    width: '314.27px',
    height: '42px',
    borderRadius: '34.6154px',
    background: '#FF856D',
    fontSize: '14px',
    lineHeight: '150%',
    color: '#FFFFFF',
    fontWeight: 500,
    padding: '8px',
    float: 'right',
  },
  createCampaignBtnText: {
    paddingLeft: '10px',
    fontSize: 16,
    lineHeight: 1.7,
  },
};
